// Outras Descricoes do produto (02/10/2026): os nomes que o CLIENTE usa ("CORDOALHA" pro cabo nu).
// A busca do servidor ja acha o produto por elas; esta peca responde a pergunta da TELA — "a busca
// achou este produto por um destes nomes?" — pra sugestao do orcamento dizer "tambem chamado de
// CORDOALHA". E' o que ensina a vendedora nova o nome do cadastro.

function semAcento(texto: string): string {
  return texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase();
}

/**
 * Devolve a outra descricao que explica o acerto, ou null quando a propria descricao ja tem
 * todas as palavras buscadas (ai nao ha o que explicar).
 */
export function outraDescricaoQueCasou(
  busca: string,
  descricao: string,
  outras: string | null | undefined,
): string | null {
  if (!outras) return null;
  const palavras = semAcento(busca).split(/\s+/).filter(Boolean);
  if (palavras.length === 0) return null;
  const desc = semAcento(descricao);
  const faltam = palavras.filter((p) => !desc.includes(p));
  if (faltam.length === 0) return null;
  // O nome que explica MAIS palavras vence: em 'fio terra', o 'TERRA' tambem esta dentro de
  // 'ATERRAMENTO', e so a contagem separa 'FIO TERRA' de 'CORDOALHA DE ATERRAMENTO'.
  let melhor: string | null = null;
  let melhorQtd = 0;
  for (const n of outras.split(',').map((s) => s.trim()).filter(Boolean)) {
    const nome = semAcento(n);
    const qtd = faltam.filter((p) => nome.includes(p)).length;
    if (qtd > melhorQtd) { melhor = n; melhorQtd = qtd; }
  }
  return melhor;
}
